"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _layout = require("@berlitz/globals/lib/components/layout");
var _SubFooter = require("./SubFooter.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SubFooter = function SubFooter(_ref) {
  var copyrightText = _ref.copyrightText,
    links = _ref.links;
  return /*#__PURE__*/_react.default.createElement(_SubFooter.Bar, {
    "data-key": "max-sub-footer"
  }, /*#__PURE__*/_react.default.createElement(_layout.Grid, null, /*#__PURE__*/_react.default.createElement(_SubFooter.Row, null, /*#__PURE__*/_react.default.createElement(_SubFooter.CopyrightText, {
    hasLinks: links.length,
    "data-key": "max-sub-footer__copyright"
  }, copyrightText), /*#__PURE__*/_react.default.createElement(_SubFooter.LegalLinks, {
    "data-key": "max-sub-footer__legal-links"
  }, links && links.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_SubFooter.LegalLink, {
      key: "legal-link-".concat(index),
      "data-key": "max-sub-footer__legal-links__link-".concat(index)
    }, item);
  })))));
};
SubFooter.defaultProps = {
  links: []
};
var _default = SubFooter;
exports.default = _default;